import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Shelf from '../shelf'
import withTotalViewableSlides from '../with-total-viewable-slides'

class Shelves extends Component {
  constructor(props) {
    super(props)

    const totalViewableSlides = this.props.totalViewableSlides
    this.totalSlides = this.props.titles.length

    this.state = {
      totalShelves: this.calcTotalShelves(this.totalSlides, totalViewableSlides),
    }

    this.calcRenderedShelves = this.calcRenderedShelves.bind(this)
  }

  calcRenderedShelves() {
    const shelves = []
    const totalSlides = this.totalSlides
    const totalViewableSlides = this.props.totalViewableSlides

    let totalSlidesInShelf = (totalViewableSlides - 1)

    const totalShelves = this.calcTotalShelves(totalSlides, totalSlidesInShelf)
    const endIndexLimit = totalSlides

    if (totalViewableSlides === 3) {
      totalSlidesInShelf = 3
    }

    if (totalViewableSlides === 2) {
      totalSlidesInShelf = 2
    }

    let beginIndex = 0

    for (let i = 0; i <= totalShelves; i++) {
      let endIndex = (beginIndex + totalSlidesInShelf)

      if (endIndex >= endIndexLimit) {
        endIndex = endIndexLimit
      }

      let titles = []

      titles = this.props.titles.slice(beginIndex, endIndex)

      if (titles.length > 0) {
        shelves.push(
          <Shelf key={i} disableSlider={true} titles={titles} />
        )
      }

      beginIndex = endIndex

      if (beginIndex === endIndexLimit) {
        break
      }
    }

    return shelves || null
  }

  calcTotalShelves(totalSlides, totalViewableSlides) {
    return Math.round(totalSlides / totalViewableSlides)
  }

  shouldComponentUpdate(nextProps, nextState, snapshot) {
    const currentTotalViewableSlides = this.props.totalViewableSlides
    const nextTotalViewableSlides = nextProps.totalViewableSlides

    if (currentTotalViewableSlides === nextTotalViewableSlides) {
      return false
    }

    return true
  }

  render() {
    let shelves = this.calcRenderedShelves()

    return (
      <React.Fragment>
        {shelves}
      </React.Fragment>
    )
  }
}

Shelves.propTypes = {
  titles: PropTypes.array,
}

export default withTotalViewableSlides(Shelves)



// WEBPACK FOOTER //
// ./src/desktop/components/shelves/index.js